<div fxLayout="column" fxLayoutAlign="center center" class="pr-56 pl-56 pb-48 pt-48 w-452">
    <div class="h3-semi-bold c-primary-gray-900 text-center"> {{ 'i18n_af_dialogSignAndSendFraudReportConfirmationDialogTitle' | translate }}</div>
    <div class="mt-16 t2 c-primary-gray-900 pre-wrap text-center" fxFlexAlign="start">
        {{ 'i18n_af_dialogSignAndSendFraudReportConfirmationDialogSubtitle' | translate }}
    </div>
    <div class="mt-16 t6 c-primary-gray-600 pre-wrap text-center" fxFlexAlign="start">
        {{ 'i18n_af_dialogSignAndSendFraudReportConfirmationDialogMoretitle' | translate }}
    </div>


    <ui-kit-button
        class="mt-32"
        (clickListener)="dialogRef.close(true)"
        [label]="'i18n_af_buttonSignAndSend' | translate"/>
    <ui-kit-button
        class="mt-12"
        type="text"
        (clickListener)="dialogRef.close(false)"
        [label]="'i18n_af_buttonCancel' | translate"/>
</div>

